/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useMemo, useCallback } from "react";
import {
  Collapse,
  Table,
  Select,
  Input,
  Modal,
  Button,
  Popconfirm,
  Form,
  message,
  DatePicker,
  Row,
  Col,
  Divider,
  Space,
  Spin,
  AutoComplete,
} from "antd";
import API from "../../api";
import urls from "../../api/urls";
//import "./style.scss";
import moment from "moment";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { checkNumbervalue, spaceBeforeCapital } from "../../utils";
import SlabSelect from "./SlabSelect";
const {
  GET_ALL_RATE_SLABS,
  GET_ALL_CALCULATION_BASIS,
  CREATE_RATE_SLAB,
  GET_ALL_CHARGES,
} = urls;
import { masterSlabAPI } from "../../api/RateCardApi";

const RateCharges = ({
  rateCharge,
  quotationRateCharge,
  stateCode,
  errors,
  setError,
  defaultRateCharge,
  calculationBasisList,
  disable,
}) => {
  const { Option } = Select;
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const { Panel } = Collapse;
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [rateCharges, setRateCharges] = useState([]);
  const [openSlabModal, setOpenSlabModal] = useState(false);

  const [rateSlabList, setRateSlabList] = useState([]);
  const [popConVisible, setPopConVisible] = useState(false);
  const [currentSlabDetails, setCurrentSlabDetails] = useState(null);
  const [openCreateSlab, setOpenCreateSlab] = useState(false);
  const [chargeHead, setChargeHead] = useState([]);
  const [slabId, setCurrentSlabId] = useState(null);
  const [fetchSlab, setFetchSlab] = useState(false);
  const [unitList, setUnitList] = useState([]);

  const disabledDate = (current) => {
    return current < moment().startOf("day");
  };
  const getFinancialEndDate = () => {
    const currentYear = moment().year();
    const financialEndYear =
      moment().month() >= 3 ? currentYear + 1 : currentYear; // Fiscal year ending March 31st
    return moment(`${financialEndYear}-03-31`, "DD-MM-YYYY");
  };

  const dateFormat = "DD-MM-YYYY";
  const chargeTypeList = useMemo(
    () => [
      { label: "Value", value: "VALUE" },
      { label: "Percentage", value: "PERCENTAGE" },
    ],
    []
  );

  const pricingTypeList = useMemo(
    () => [
      { label: "Fixed", value: "FIXED" },
      { label: "Slab", value: "SLAB" },
    ],
    []
  );

  const appliesOnList = useMemo(
    () => [
      { label: "Shipment", value: "SHIPMENT" },
      { label: "Invoice", value: "INVOICE" },
    ],
    []
  );

  const defaultUnitList = [
    { label: "Grams", value: "GRAMS" },
    { label: "Inr", value: "INR" },
  ];

  useEffect(() => {
    setUnitList(defaultUnitList);
  }, []);

  useEffect(() => {
    // Set one default item
    initiateFormSlab();
  }, [form1]);

  const initiateFormSlab = () => {
    form1.setFieldsValue({
      slab: [{ minValue: "", maxValue: "", rateType: null, value: "" }],
    });
  };

  useEffect(() => {
    rateCharge(
      rateCharges.filter((item) => selectedRowKeys.includes(item.head))
    );
  }, [rateCharges, selectedRowKeys]);

  // useEffect(() => {
  //   if (defaultRateCharge?.length > 0) {
  //     getAllCharge(defaultRateCharge);
  //   }
  // }, [defaultRateCharge]);

  useEffect(() => {
    getAllCharge();
  }, [quotationRateCharge]);

  const getAllCharge = async (datas) => {
    setRateCharges(
      quotationRateCharge.map((item) => {
        return {
          ...item,
          head: item?.chargesHead,
          _id: item?.chargesHead,
          key: item?.chargesHead,
          chargeType: item?.rateType || null,
          pricingType: item?.pricingType || null,
          appliesOn: item?.appliesOn || null,
          rate: item?.rate || null,
          percentage: item?.percentage || null,
          slabId: item?.slabId || null,
          // activeType: item?.rate
          //   ? "rate"
          //   : item?.percentage
          //   ? "percentage"
          //   : item?.slabId
          //   ? "slabId"
          //   : "rate",
          activeType:
            item?.rate != null
              ? "rate"
              : item?.percentage != null
              ? "percentage"
              : item?.slabId
              ? "slabId"
              : "rate",

          rateSlab: null,
        };
      })
    );

    setSelectedRowKeys(
      quotationRateCharge?.map(({ chargesHead }) => chargesHead)
    );
  };

  // useEffect(() => {
  //   if (defaultRateCharge?.length > 0 && quotationRateCharge?.length > 0) {
  //     let data = rateCharges.map((item) => {
  //       const matchedCharge = quotationRateCharge.find(
  //         (charge) => charge.chargesHead === item?.head
  //       );

  //       return {
  //         ...item,
  //         chargeType: matchedCharge?.rateType || null,
  //         pricingType: matchedCharge?.pricingType || null,
  //         appliesOn: matchedCharge?.appliesOn || null,
  //         rate: matchedCharge?.rate || null,
  //         percentage: matchedCharge?.percentage || null,

  //         activeType: matchedCharge?.rate
  //           ? "rate"
  //           : matchedCharge?.percentage
  //           ? "percentage"
  //           : matchedCharge?.slabId
  //           ? "slabId"
  //           : "rate",
  //         rateSlab: null,
  //         slabId: matchedCharge?.slabId || null,
  //       };
  //     });
  //     quotationRateCharge.forEach((items) => {
  //       const exists = data.some((entry) => entry.head === items.chargesHead);

  //       if (!exists) {
  //         data.push({
  //           _id: items.chargesHead,
  //           head: items.chargesHead,
  //           key: items.chargesHead,
  //           calculationBasis: items.calculationBasis || null,
  //           global: false,
  //           chargeType: items.rateType || null,
  //           pricingType: items.pricingType || null,
  //           appliesOn: items.appliesOn || null,
  //           rate: items.rate || null,
  //           percentage: items.percentage || null,
  //           slabId: items.slabId || null,
  //           //activeType: items.rateType === "PERCENTAGE" ? "percentage" : "rate",
  //           activeType: items?.rate
  //             ? "rate"
  //             : items?.percentage
  //             ? "percentage"
  //             : items?.slabId
  //             ? "slabId"
  //             : "rate",
  //           rateSlab: null,
  //         });
  //       }
  //     });

  //     setSelectedRowKeys(data?.map(({ head }) => head));
  //     setRateCharges([...data]);
  //   }
  // }, [quotationRateCharge, defaultRateCharge]);

  const onSelectChange = useCallback((newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  }, []);

  const changeRateCharge = (value, type, record) => {
    setRateCharges((prevCharges) =>
      prevCharges.map((item) => {
        if (item._id !== record._id) return item; // Skip if not matching

        const updatedItem = { ...item, [type]: value };

        if (type === "chargeType") {
          updatedItem.activeType =
            value === "VALUE"
              ? record?.pricingType === "SLAB"
                ? "slabId"
                : "rate"
              : record?.pricingType === "SLAB"
              ? "slabId"
              : "percentage";

          if (updatedItem.activeType === "rate") {
            updatedItem.percentage = null;
          } else if (updatedItem.activeType === "percentage") {
            updatedItem.rate = null;
          }
        } else if (type === "pricingType") {
          updatedItem.activeType =
            value === "SLAB"
              ? "slabId"
              : record?.chargeType === "VALUE"
              ? "rate"
              : "percentage";
        }

        return updatedItem;
      })
    );
  };

  const changeRateSlab = (val, record) => {
    const { activeType, _id } = record;
    const propertyMap = {
      slabId: "slabId",
      rate: "rate",
      percentage: "percentage",
    };
    setRateCharges((prevCharges) =>
      prevCharges.map((item) =>
        item._id == _id ? { ...item, [propertyMap[activeType]]: val } : item
      )
    );
  };

  const addMoreCharge = async (val) => {
    if (
      rateCharges?.some(
        (item) =>
          item?.head?.trim()?.toUpperCase() === val?.head?.trim()?.toUpperCase()
      )
    ) {
      message.error("Charge head already exists");
      return;
    }
    setRateCharges((prevCharges) => [
      ...prevCharges,
      {
        _id: Math.random(),
        head: val?.head,
        calculationBasis: val?.calculationBasis,
        chargeType: null,
        pricingType: null,
        appliesOn: null,
        rate: null,
        percentage: null,
        slabId: null,
        activeType: "rate",
        global: false,
      },
    ]);
    setPopConVisible(false);
    form.resetFields();
  };

  const createSlab = async (slabId, options, head) => {
    if (!slabId) {
      setOpenCreateSlab(true);
    } else {
      const data = options?.find((e) => e._id == slabId);
      setCurrentSlabId(slabId);
      //   const response = await API.Api(
      //     `${GET_ALL_RATE_SLABS}/${data?.name}`
      //   ).get();
      let response = await masterSlabAPI.getSlabById(slabId);

      if (response?.status) {
        let res = response?.response?.data;
        setCurrentSlabDetails(res);
        setOpenCreateSlab(true);
        let slabs = res?.slab || [];
        const additionalVal = slabs?.find((item) => item?.volume);
        const additionalValIndex = slabs.findIndex((item) => item?.volume);

        if (additionalValIndex !== -1) {
          slabs.splice(additionalValIndex, 1); // remove the item with `volume`
        }
        form1.setFieldsValue({
          name: res?.name,
          chargesHead: res?.chargesHead,

          unit: res?.unit,
          slab: slabs,
          volume: additionalVal?.volume,
          rateType: additionalVal?.rateType,
          value: additionalVal?.value,
        });
      } else {
        message.error(
          response?.response?.data?.message || "Can't fetch slab details."
        );
      }
    }
  };

  const submitCreateSlab = async (val) => {
    let slabs = val?.slab;
    slabs = slabs.map((item) => ({
      ...item,
      minValue: parseFloat(item?.minValue),
      //volume: parseFloat(item?.volume),
      value: parseFloat(item?.value),
      maxValue: parseFloat(item?.maxValue),
    }));
    if (val?.volume) {
      slabs.push({
        minValue: parseFloat(slabs[slabs.length - 1]?.maxValue),
        volume: parseFloat(val?.volume),
        rateType: val?.rateType,
        value: parseFloat(val?.value),
      });
    }
    let payload = {
      chargesHead: val?.chargesHead,
      unit: val?.unit,
      slab: slabs,
      name: val?.name,
    };

    let res;
    if (slabId) {
      res = await masterSlabAPI.patchSlab(slabId, payload);
    } else {
      res = await masterSlabAPI.createSlab(payload);
    }

    if (res?.status) {
      //initialize();
      setFetchSlab(!fetchSlab);
      const data = res?.response?.data;
      //if (data && slabId) {
      if (!slabId) {
        setTimeout(() => {
          const updatedCharges = rateCharges?.map((item) =>
            item?.head == data?.chargesHead
              ? {
                  ...item,
                  slabId: data.rateCardId,
                  activeType: "slabId",
                  _id: data?.chargesHead,
                }
              : item
          );
          setRateCharges([...updatedCharges]);
        }, 100);

        // const updatedCharges = rateCharges?.map((item) =>
        //   item?.head == data?.chargesHead
        //     ? {
        //         ...item,
        //         slabId: data._id,
        //         activeType: "slabId",
        //         _id: data?.chargesHead,
        //       }
        //     : item
        // );
        //console.log(updatedCharges, "updatedCharges");
        //changeRateCharge(data._id, "slabId", updatedCharges);
        //setRateCharges([...updatedCharges]);
      }

      form1.resetFields();
      initiateFormSlab();
      setCurrentSlabId(null);
      //}
      setOpenCreateSlab(false);
    } else {
      message.error(res?.response?.data?.message || "Internal server error.");
    }
  };

  const columns = useMemo(
    () => [
      {
        title: "Charge Head",
        dataIndex: "head",
        render: (text, record) => (
          <>
            <span className="text-gray-600">{text}</span>
            {errors?.includes(text) && (
              <span style={{ color: "red" }}> Fill all the values</span>
            )}
          </>
        ),
      },
      {
        title: "Pricing Type",
        dataIndex: "pricingType",
        render: (text, record) => (
          <Select
            disabled={disable}
            options={pricingTypeList}
            className="rate-select"
            placeholder="Select"
            value={text}
            onChange={(value) => {
              if (errors) {
                setError();
              }
              changeRateCharge(value, "pricingType", record);
            }}
          />
        ),
      },
      {
        title: "Charge Type",
        dataIndex: "chargeType",
        render: (text, record) =>
          record.pricingType !== "SLAB" ? (
            <Select
              disabled={disable}
              options={chargeTypeList}
              className="rate-select"
              placeholder="Select"
              value={text}
              onChange={(value) => {
                if (errors) {
                  setError();
                }
                changeRateCharge(value, "chargeType", record);
              }}
              style={{ width: "120px" }}
            />
          ) : (
            "N/A"
          ),
      },
      {
        title: "Applied On",
        dataIndex: "appliesOn",
        render: (text, record) => (
          <Select
            disabled={disable}
            options={appliesOnList}
            className="rate-select"
            placeholder="Select"
            value={text}
            onChange={(value) => {
              if (errors) {
                setError();
              }
              changeRateCharge(value, "appliesOn", record);
            }}
          />
        ),
      },
      {
        title: "Calculation Basis",
        dataIndex: "calculationBasis",
        render: (text) => spaceBeforeCapital(text),
      },

      {
        title: "Rate/Item/Slab ID",
        dataIndex: "activeType",
        render: (text, record) => (
          <>
            {record?.activeType === "slabId" ? (
              <div className="d-flex">
                <SlabSelect
                  disable={disable}
                  predefined={record.global}
                  head={record.head}
                  key={record.head}
                  value={record.slabId}
                  onChange={(val) => {
                    if (errors) {
                      setError();
                    }
                    changeRateCharge(val, "slabId", record);
                  }}
                  createSlab={(id, options) => createSlab(id, options)}
                  //setRateSlabList1={(val) => getCurrectRateCharge(val)}
                  slabFetch={fetchSlab}
                />
              </div>
            ) : record?.activeType === "rate" ||
              record?.activeType === "percentage" ? (
              <Input
                disabled={disable}
                style={{ width: "300px" }}
                onChange={(e) => {
                  if (errors) {
                    setError();
                  }
                  changeRateSlab(e.target.value, record);
                }}
                value={record?.rate || record?.percentage}
                onKeyPress={(event) => {
                  if (checkNumbervalue(event)) {
                    event.preventDefault();
                  }
                }}
              />
            ) : (
              record[text]
            )}
          </>
        ),
      },
    ],
    [
      chargeTypeList,
      appliesOnList,
      calculationBasisList,
      pricingTypeList,
      //changeRateCharge,
      errors,
      chargeHead,
      defaultRateCharge,
      fetchSlab,
    ]
  );

  return (
    <>
      <Collapse collapsible={"header"} defaultActiveKey={["1"]}>
        <Panel header="Value Added Charges" key="1">
          <Table
            rowSelection={{
              selectedRowKeys,
              onChange: onSelectChange,
              type: "checkbox",
              getCheckboxProps: (record) => ({
                disabled: record.global || disable,
              }),
            }}
            columns={columns}
            dataSource={rateCharges}
            rowKey="head"
            className="rate-charge-table"
            pagination={false}
          />
          <div className="ml-2 space-between">
            <Popconfirm
              icon={null}
              placement="top"
              visible={popConVisible}
              onCancel={() => setPopConVisible(false)}
              title={
                <Form
                  className="global-form"
                  layout="vertical"
                  form={form}
                  scrollToFirstError={{
                    behavior: "smooth",
                    block: "center",
                    inline: "center",
                  }}
                  onFinish={addMoreCharge}
                >
                  <Form.Item
                    name="head"
                    label="Charge Head"
                    rules={[
                      {
                        required: true,
                        message: "Enter charge head",
                      },
                    ]}
                  >
                    {/* <Input
                      placeholder="Enter charge head"
                      style={{ borderRadius: "5px" }}
                    /> */}
                    <AutoComplete
                      options={defaultRateCharge?.map((item) => ({
                        label: spaceBeforeCapital(item?.head),
                        value: item?.head,
                      }))}
                      placeholder="Select charge head"
                      filterOption={(inputValue, option) =>
                        option.value
                          .toUpperCase()
                          .indexOf(inputValue.toUpperCase()) !== -1
                      }
                    />
                  </Form.Item>
                  <Form.Item
                    name="calculationBasis"
                    label="Select Calculation Basis"
                    rules={[
                      {
                        required: true,
                        message: "Select calculation basis",
                      },
                    ]}
                  >
                    <Select
                      options={calculationBasisList}
                      placeholder="Select"
                    />
                  </Form.Item>
                </Form>
              }
              onConfirm={() => {
                form.submit();
              }}
              okText="CREATE"
              cancelText="CANCEL"
            >
              {!disable && (
                <Button
                  className="save-btn mt-05"
                  onClick={() => setPopConVisible(true)}
                >
                  Add More
                </Button>
              )}
            </Popconfirm>
            {!disable &&
              rateCharges?.some((rates) => rates?.pricingType === "SLAB") >
                0 && (
                <Button
                  className="save-btn mt-05 mr-2"
                  onClick={() => createSlab()}
                >
                  CREATE SLAB
                </Button>
              )}
          </div>
        </Panel>
      </Collapse>

      <Modal
        title={
          slabId ? `Attach Slab (${currentSlabDetails?.name})` : "Create Slab"
        }
        open={openCreateSlab}
        onCancel={() => {
          setOpenCreateSlab(false);
          form1.resetFields();
          initiateFormSlab();
          setCurrentSlabDetails(null);
          setCurrentSlabId(null);
        }}
        width={700}
        footer={
          <div className="d-flex flex-end" style={{ padding: "1rem 0 0 0" }}>
            <Button
              onClick={() => {
                setOpenCreateSlab(false);
                form1.resetFields();
                initiateFormSlab();
                setCurrentSlabDetails(null);
                setCurrentSlabId(null);
              }}
              className="cancel-btn w-13"
            >
              {"CANCEL"}
            </Button>
            {!disable && (
              <Button
                onClick={() => form1.submit()}
                className="save-btn ml-1 w-13"
              >
                {"SUBMIT"}
              </Button>
            )}
          </div>
        }
      >
        <div>
          <Form
            className="global-form"
            layout="vertical"
            form={form1}
            scrollToFirstError={{
              behavior: "smooth",
              block: "center",
              inline: "center",
            }}
            onFinish={submitCreateSlab}
            // initialValues={{
            //   slab: { minValue: 0 },
            // }}
          >
            <Row className="global-form-row" gutter={10}>
              <Col className="form-inputs" span={8}>
                <Form.Item
                  name="name"
                  label="Slab Name"
                  rules={[
                    {
                      required: true,
                      message: "Enter slab name",
                    },
                  ]}
                >
                  <Input placeholder="Enter slab name" disabled={disable} />
                </Form.Item>
              </Col>
              <Col className="form-inputs" span={8}>
                <Form.Item
                  name="chargesHead"
                  label="Charge Head"
                  rules={[
                    {
                      required: true,
                      message: "Enter charge head",
                    },
                  ]}
                >
                  {/* <Input placeholder="Enter charge head" disabled={disable} /> */}
                  <Select
                    options={rateCharges
                      ?.filter((item) => item?.pricingType === "SLAB")
                      ?.map((item) => ({
                        label: item?.head,
                        value: item?.head,
                        calculationBasis: item?.calculationBasis,
                      }))}
                    placeholder="Select charge head"
                    disabled={disable}
                    onChange={(value, data) => {
                      let temp = calculationBasisList?.find(
                        (item) => item?.value === data?.calculationBasis
                      )?.unit;
                      let unit = temp?.map((item) => ({
                        label: spaceBeforeCapital(item),
                        value: item,
                      }));
                      if (unit) {
                        setUnitList(unit);
                        form1.setFieldsValue({
                          unit: unit[0]?.value,
                        });
                      } else {
                        setUnitList(defaultUnitList);
                        form1.setFieldsValue({
                          unit: defaultUnitList[0]?.value,
                        });
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Col className="form-inputs" span={8}>
                <Form.Item
                  name="unit"
                  label="Unit"
                  rules={[
                    {
                      required: true,
                      message: "Enter unit",
                    },
                  ]}
                >
                  <Select
                    options={unitList}
                    placeholder="Select unit"
                    disabled={disable}
                  />
                </Form.Item>
              </Col>

              <Divider>Rate Slabs</Divider>

              <Form.List name="slab">
                {(fields, { add, remove }) => (
                  <>
                    <div className="m-5">
                      {fields.map((field, index) => (
                        <Space
                          key={`slab-item-${field.name}-${index}`}
                          align="center"
                          size={"middle"}
                          className="ml-05"
                        >
                          <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, curValues) =>
                              prevValues.area !== curValues.area ||
                              prevValues.sights !== curValues.sights
                            }
                          >
                            {() => (
                              <Form.Item
                                {...field}
                                label="Min Value"
                                name={[field.name, "minValue"]}
                                rules={[
                                  {
                                    required: true,
                                    message: "Missing min value",
                                  },
                                ]}
                                onKeyPress={(event) => {
                                  if (checkNumbervalue(event)) {
                                    event.preventDefault();
                                  }
                                }}
                              >
                                <Input
                                  placeholder="Min Value"
                                  style={{ width: "150px" }}
                                  disabled={disable}
                                />
                              </Form.Item>
                            )}
                          </Form.Item>
                          {/* {index !== fields.length - 1 && ( */}
                          <Form.Item
                            {...field}
                            label="Max Value"
                            name={[field.name, "maxValue"]}
                            rules={[
                              {
                                required: true,
                                message: "Missing max value",
                              },
                              () => ({
                                validator(_, value) {
                                  const minValue =
                                    form1.getFieldValue("slab")?.[index]
                                      ?.minValue;

                                  if (parseInt(value) <= parseInt(minValue)) {
                                    return Promise.reject(
                                      new Error(
                                        `Max Value must be greater than ${minValue}`
                                      )
                                    );
                                  }
                                  return Promise.resolve();
                                },
                              }),
                            ]}
                            onKeyPress={(event) => {
                              if (checkNumbervalue(event)) {
                                event.preventDefault();
                              }
                            }}
                          >
                            <Input
                              placeholder="Max Value"
                              style={{ width: "150px" }}
                              disabled={disable}
                            />
                          </Form.Item>
                          {/* )} */}

                          <Form.Item
                            {...field}
                            label="Rate Type"
                            name={[field.name, "rateType"]}
                            rules={[
                              {
                                required: true,
                                message: "Missing rate type",
                              },
                            ]}
                          >
                            <Select
                              options={chargeTypeList}
                              placeholder="Select rate type"
                              style={{ width: "150px" }}
                              disabled={disable}
                            />
                          </Form.Item>

                          <Form.Item
                            {...field}
                            label="Value"
                            name={[field.name, "value"]}
                            rules={[
                              {
                                required: true,
                                message: "Missing value",
                              },
                            ]}
                            onKeyPress={(event) => {
                              if (checkNumbervalue(event)) {
                                event.preventDefault();
                              }
                            }}
                          >
                            <Input
                              placeholder="Value"
                              style={{ width: "150px" }}
                              disabled={disable}
                            />
                          </Form.Item>

                          {!disable && (
                            <MinusCircleOutlined
                              onClick={() => remove(field.name)}
                            />
                          )}
                        </Space>
                      ))}
                    </div>

                    <div className="center w-100 mt-05">
                      <Form.Item>
                        <Button
                          type="dashed"
                          onClick={() => add()}
                          block
                          icon={<PlusOutlined />}
                          className="save-btn"
                          disabled={disable}
                        >
                          Add New Slab
                        </Button>
                      </Form.Item>
                    </div>
                  </>
                )}
              </Form.List>
              <Space align="center" size={"middle"} className="ml-05">
                <Form.Item
                  label="Additional Value"
                  name={"volume"}
                  onKeyPress={(event) => {
                    if (checkNumbervalue(event)) {
                      event.preventDefault();
                    }
                  }}
                >
                  <Input
                    placeholder="Additional Value"
                    style={{ width: "200px" }}
                    disabled={disable}
                  />
                </Form.Item>

                <Form.Item label="Rate Type" name={"rateType"}>
                  <Select
                    options={chargeTypeList}
                    placeholder="Select rate type"
                    style={{ width: "200px" }}
                    disabled={disable}
                  />
                </Form.Item>

                <Form.Item
                  label="Value"
                  name={"value"}
                  onKeyPress={(event) => {
                    if (checkNumbervalue(event)) {
                      event.preventDefault();
                    }
                  }}
                >
                  <Input
                    placeholder="Value"
                    style={{ width: "200px" }}
                    disabled={disable}
                  />
                </Form.Item>
              </Space>
            </Row>
          </Form>
        </div>
      </Modal>
    </>
  );
};

export default RateCharges;
